<template>
  <div class="NavigationBar" >
<Language @getLanguageMap='getLanguageMap'></Language>

<div class="crumbs" style="padding-top: 80px;">
  <div class="container">
    <p class="title">{{lastShopTypeName ? languageMap[lastShopTypeName] : ''}}</p>
    <div class="childs"> 
        <span v-if="shopType">
          <a href="javascript:void(0);" class="hoverText" @click="shopTypeClick(shopType, shopType.id)">{{languageMap[shopType.name]}}</a> &gt; 
        </span>
        <span v-if="shopType && shopType.shopType">
          <a href="javascript:void(0);" class="hoverText" @click="shopTypeClick(shopType.shopType, shopType.id)">{{languageMap[shopType.shopType.name]}}</a> &gt; 
        </span>
        <span v-if="shopType && shopType.shopType && shopType.shopType.shopType">
          <a href="javascript:void(0);" class="hoverText" @click="shopTypeClick(shopType.shopType.shopType, shopType.id)">{{languageMap[shopType.shopType.shopType.name]}}</a> &gt; 
        </span>
     </div>
  </div>
</div>

  </div>
</template>

<style>

</style>
<style lang="sass" scoped>

</style>
<script>
import store from "@/store";
import config from "@/config";
import Language from "@/components/front/Language.vue";

export default {
  name: "NavigationBar",
  props: {},
  data() {
    return {
      languageMap:{},
      shopType: null,
      lastShopTypeName: ''
    };
  },
  mounted() {
    // this.initLanguage();
    this.init();

    this.queryNavigationBarData(this.$route.query.type ? this.$route.query.type : this.$route.query.id);

  },
    watch: {
　　// 利用watch方法检测路由变化：
　　'$route': function (to, from) {
     this.queryNavigationBarData(to.query.type ? to.query.type : to.query.id);
　　}
},
  beforeDestroy() {
  },
  methods: {
    queryNavigationBarData(id) {  //查询导航数据
      let url =  config.url + "FrontController/queryNavigationBarData.action";
      let param = {id : id};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
            this.shopType=data.data;
            this.lastShopTypeName = ''; 
            if(this.shopType){
              let lastShopType = this.shopType;
                if(this.shopType.shopType){
                  lastShopType = this.shopType.shopType;
                    if(this.shopType.shopType.shopType) {
                      lastShopType = this.shopType.shopType.shopType;
                      this.lastShopTypeName = this.shopType.shopType.shopType.name;
                    }else{
                      this.lastShopTypeName = this.shopType.shopType.name;
                    }
                }else{
                    this.lastShopTypeName = this.shopType.name;
                }
                this.$emit('getLastShopType',lastShopType);
            }
        }
      }) .catch(err => {
        console.log(err);
      });
    },
    initLanguage(){  //初始化
       let languageObj=this.getCookie("language");
      if(languageObj && languageObj != 'null'){
        let language=JSON.parse(languageObj);
        this.fileId=language.id;
        this.loadLanguageFile(language.fileName,{count:1});
      }else{
        this.fileId=1;
        this.loadLanguageFile("chinese.txt",{count:1});
      }
    },
    async loadLanguageFile(fileName,countObj){  //加载语言文件
     if(countObj.count > 3 ){
       return;
     }
      let res = await $.ajax({
                type: "get",
                url: "./language/"+fileName,
                dataType: "text",
                async:false,
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
               });
          if(res){ //加载成功
            // console.log("res="+res);
            let strArray=res.split("\n");
            for(let i=0;i<strArray.length;i++){
                let obj=strArray[i].replace("\r","");
              if(fileName == 'chinese.txt'){
                this.languageMap[obj]=obj;
              } else {  
                let mapArray=obj.split("==");
                if(mapArray.length >= 2){
                  this.languageMap[mapArray[0]]=mapArray[1];
                }
              }
            }
            this.languageMap['fileName']=fileName;
            this.$emit('getLanguageMap',this.languageMap);
            this.$forceUpdate();//强制重新渲染视图
            return;
          }
           countObj.count++;
           this.loadLanguageFile(fileName,countObj);
    },
    init(){  
     
    },
 getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    shopTypeClick(shopTypeObj, oneId){
      location.href = (shopTypeObj.type==1 ? shopTypeObj.href : config.htmlContentVueUrl)+'?id='+shopTypeObj.id+'&oneId='+oneId+'&timeStamp='+(new Date().getTime());
    },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
    }

  },
  components: {
    Language
  }
};
</script>

